import { Component } from '@angular/core';

@Component({
  selector: 'app-x-search-list-title',
  standalone: true,
  imports: [],
  templateUrl: './x-search-list-title.component.html',
  styleUrl: './x-search-list-title.component.less'
})
export class XSearchListTitleComponent {

}
